import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState = false

const autoSwitchLongHaulSlice = createSlice({
  name: 'autoSwitchLongHaul',
  initialState,
  reducers: {
    autoSwitchLongHaul: (state, action: PayloadAction<any>) => action.payload,
  },
  extraReducers: () => {},
})
export const autoSwitchLongHaulActionsCreator = autoSwitchLongHaulSlice.actions

export default autoSwitchLongHaulSlice
